<template>
  <f7-page page="main-menu" class="main-menu-page">
    <f7-list media-list class="no-margin main-menu-fixed">
      <f7-list-item
        :title="getNombreUser()"
        :header="getUsername()"
        class="padding-vertical"
      >
        <div slot="footer">
          <f7-link href="/perfil/" view=".view-main">Mi perfil</f7-link>|
          <f7-link @click="closeSession()">Cerrar sesión</f7-link>
        </div>
        <img
          v-if="0"
          slot="media"
          src="https://cdn.framework7.io/placeholder/fashion-88x88-3.jpg"
          width="44"
        />
        <f7-icon
          v-else
          slot="media"
          :f7="getRoleIcon()"
          style="font-size:3rem;"
          :class="'text-color-' + getRoleColor()"
          v-tooltip="getRoleLabel()"
        />
      </f7-list-item>
    </f7-list>

    <f7-toolbar bottom>
      <span class="text-color-gray">{{pie}}</span>
    </f7-toolbar>

    <div class="menu-filter main-menu-fixed">
      <div class="menu-filter-wrap">
        <f7-icon f7="search" class="menu-filter-icon"></f7-icon>
        <input
          type="text"
          class="menu-filter-input"
          :placeholder="$t('common.buscar') || 'Buscar...'"
          v-model="filter"
        />
        <f7-link v-if="filter" icon-f7="xmark_circle_fill" class="menu-filter-clear" @click="filter = ''"></f7-link>
      </div>
    </div>

    <f7-list class="main-menu-scroll">
      <ul>
        <div class="div-menu-item" v-for="(item,index)  in filteredItems"
          :key="'menu-item-' + index">
          <f7-list-item
            v-if="(!!!item.target || target === item.target) && (!item.hijos || !item.hijos.length)"
            :link="item.link"
            :external="abreComoExterno(item)"
            :title="$t(item.title)"
            :color="item.color||''"
            view=".view-main"
            panel-close
          >
            <f7-icon v-if="item.icon" slot="media" :f7="item.icon" :color="item.color||''"></f7-icon>
            <!-- #59 · el badge de «Vacaciones»: cuántas solicitudes le esperan a quien aprueba.
                 Se decide por el `link` y no por el título, que es una clave de traducción y
                 puede cambiar de texto. -->
            <f7-badge v-if="badgeDe(item)" color="red" slot="after">{{ badgeDe(item) }}</f7-badge>
          </f7-list-item>
          <f7-list-item
            v-else-if="(!!!item.target || target === item.target) && item.hijos && item.hijos.length"
            :title="$t(item.title)"
            view=".view-main"
            accordion-item
            :accordion-item-opened="!!filter"
          >
            <f7-icon v-if="item.icon" slot="media" :f7="item.icon" :style="'color: '+(item.color||'')"></f7-icon>
            <f7-accordion-content  :style="'border-left: 10px solid '+item.color+';border-right: 1px solid '+item.color+';'">
              <ul v-for="(hijo,indexHijo)  in item.hijos"
                :key="'menu-item-hijo' + index + '-' + indexHijo">
                <f7-list-item
                  :link="hijo.link"
                  :external="abreComoExterno(hijo)"
                  :title="$t(hijo.title)"
                  view=".view-main"
                  panel-close
                >
                  <f7-icon v-if="hijo.icon" slot="media" :f7="hijo.icon" :style="'color: '+(hijo.color||'')"></f7-icon>
                  <f7-badge v-if="badgeDe(hijo)" color="red" slot="after">{{ badgeDe(hijo) }}</f7-badge>
                </f7-list-item>
              </ul>
            </f7-accordion-content>
          </f7-list-item>
        </div>
        <div v-if="filter && !filteredItems.length" class="text-color-gray text-align-center padding">
          Sin coincidencias
        </div>
      </ul>
    </f7-list>
  </f7-page>
</template>
<style>
.panel-left.panel-in-breakpoint:before {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 1px;
  background: rgba(0, 0, 0, 0.1);
  content: "";
  z-index: 6000;
}
.menu-filter + .list {
  margin-top: 0 !important;
}
/* Perfil y buscador fijos; solo el listado de opciones hace scroll */
.main-menu-page .page-content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.main-menu-page .main-menu-fixed {
  flex-shrink: 0;
}
.main-menu-page .main-menu-scroll {
  flex: 1 1 auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  min-height: 0;
}
</style>
<style scoped>
.menu-filter {
  padding: 8px 12px;
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  z-index: 10;
  margin-bottom: 0;
}
.menu-filter + .list {
  margin-top: 0 !important;
}
.menu-filter-wrap {
  display: flex;
  align-items: center;
  background: #f1f3f5;
  border-radius: 8px;
  padding: 0 8px;
}
.menu-filter-icon {
  font-size: 18px;
  color: #6c757d;
  margin-right: 6px;
}
.menu-filter-input {
  flex: 1 1 auto;
  border: none;
  outline: none;
  background: transparent;
  height: 32px;
  font-size: 14px;
  color: #212529;
}
.menu-filter-clear {
  font-size: 16px;
  color: #adb5bd;
}
</style>
<script>
import Flash from '../js/FlashUtils';
import Utils from '../js/Utils';
import RhBandejaVacaciones, { EVENTO_VACACIONES_RESUELTA } from '../js/db/RhBandejaVacaciones.js';
import { EventBus } from '../js/EventBus.js';
import carrilPeticiones from '../js/utils/carrilPeticiones.js';
import identidadSesion, { haySesion } from '../js/utils/identidadSesion.js';
import { pieConEntorno } from '../js/entornoDespliegue';
export default {
  data() {
    return {
      version: process.env.BUILDDATE,
      target: process.env.TARGET,
      filter: "",
      /**
       * #59 · Cuántas solicitudes de vacaciones le esperan a quien aprueba. 0 = ninguna, y
       * entonces no se pinta nada: un «0» en rojo es ruido.
       */
      badgeVacaciones: 0,
      Utils
    };
  },
  created: function() {
    // #59 · El badge se pide al montar y otra vez cada vez que se resuelve una solicitud, así que
    // puede haber dos respuestas en vuelo. Por el carril, que es donde vive en este repo la regla
    // de «solo contesta la última»: sin él, la respuesta de la consulta vieja llegaba después de
    // la recarga y pintaba el contador de antes encima del bueno, dejándolo obsoleto el resto de
    // la sesión (revisión CODEX del PR #1735). No va en `data` porque no se pinta.
    this.carrilBadge = carrilPeticiones();
  },
  mounted: function() {
    // #59 · Al montar se pide **solo si ya hay sesión** (una recarga con la sesión guardada); sin
    // ella no se pide nada y se espera el aviso de abajo. Este menú se monta también en la pantalla
    // de login —la vista izquierda arranca siempre en `/main-menu/`—, y allí la petición se iba sin
    // token para nada: el servidor solo puede contestarle un 401 (revisión CODEX del PR #1735).
    // Que ese 401 ya no eche a quien entre mientras llega lo garantiza `cierreDeSesionPor401`
    // dentro de `sendRequest`; esto es lo otro, no gastar una petición que no puede traer nada.
    this.cargarBadgeVacaciones();
    // #59 · Este menú se monta UNA vez: vive en la vista izquierda, que es persistente, y no se
    // vuelve a crear al navegar. Así que todo lo que cambie el badge después tiene que avisarle,
    // porque él no se va a enterar solo. Lo que lo cambia desde esta sesión es resolver una
    // solicitud, y eso se puede hacer desde la bandeja y desde el día amarillo del calendario:
    // las dos mandan este aviso.
    EventBus.$on(EVENTO_VACACIONES_RESUELTA, this.cargarBadgeVacaciones);
    // #59 · Y lo otro que lo cambia es cambiar de persona: cerrar sesión y entrar con otra cuenta
    // en la misma pestaña NO vuelve a montar este menú, así que el contador se quedaba con las
    // solicitudes que esperaban a la cuenta anterior —y una petición suya que siguiera en vuelo
    // podía escribirlo después del cambio— (revisión CODEX del PR #1735). Al cerrar se apaga; al
    // abrir se pregunta por la cuenta nueva, que es la única que puede contestarlo.
    //
    // El aviso por el que se espera es `app:auth-ready` y no `app:session:open`: es el que la
    // aplicación da cuando ya hay sesión con la que pedir, tanto al entrar (`saveSession`) como al
    // recargar con una guardada (`startSession`), y es el mismo que usa la campana de alertas —otro
    // componente persistente— exactamente por este motivo.
    EventBus.$on('app:session:close', this.olvidarBadgeVacaciones);
    EventBus.$on('app:auth-ready', this.cargarBadgeVacaciones);
  },
  beforeDestroy: function() {
    // El `$off` aunque el menú no se destruya en la práctica: si algún día se recreara, dos
    // instancias escuchando dejarían el bus reteniendo la vieja y pidiendo la bandeja dos veces.
    EventBus.$off(EVENTO_VACACIONES_RESUELTA, this.cargarBadgeVacaciones);
    EventBus.$off('app:session:close', this.olvidarBadgeVacaciones);
    EventBus.$off('app:auth-ready', this.cargarBadgeVacaciones);
  },
  computed: {
    // El pie dice la fecha de build Y el entorno de despliegue, que son dos datos distintos:
    // `BUILDDATE` acaba en PRO siempre que el bundle se compila optimizado, y los previews se
    // compilan optimizados, asi que por si solo hacia pasar pruebas por produccion (#229).
    pie: function() {
      return pieConEntorno(this.version, process.env.ENTORNO_ETIQUETA);
    },
    menu: function() {
      const baseMenu = !!Utils.getMenu() ? Utils.getMenu() : {items:[]};
      // El bloque "dashboard" debe llegar entero desde el backend filtrado por rol.
      // Item anadido al doc Mongo del menu (config._id=6053734254d5750600b566b9) en seed PR1.6.
      // El bloque "tarifas" debe llegar entero desde el backend filtrado por rol.
      // No reinyectamos aqui: el filtro client-side era un bypass de roles
      // (un usuario podia manipular localStorage para ver entradas que el
      // backend no le habia enviado).
      return baseMenu;
    },
    filteredItems: function() {
      const self = this;
      const items = (self.menu && self.menu.items) || [];
      const term = self.normalize(self.filter);
      if (!term) return items;
      const result = [];
      for (let i = 0; i < items.length; i++) {
        const it = items[i];
        const titleMatch = self.normalize(self.$t(it.title)).indexOf(term) > -1;
        const hijos = (it.hijos || []).filter(h => self.normalize(self.$t(h.title)).indexOf(term) > -1);
        if (titleMatch) {
          result.push(it);
        } else if (hijos.length) {
          result.push({ ...it, hijos });
        }
      }
      return result;
    }
  },
  methods: {
    /**
     * #59 · El badge de la entrada «Vacaciones». Se reconoce por el `link` y no por el título,
     * que es una clave de traducción y puede cambiar de texto sin avisar.
     *
     * Solo esa entrada lleva badge hoy: si algún día hubiera más, aquí es donde se decide.
     */
    badgeDe: function(item) {
      if (!item || item.link !== '/vacaciones/') return 0;
      return this.badgeVacaciones;
    },
    /**
     * Lo pregunta al servidor al montar el menú y cada vez que esta sesión resuelve una solicitud
     * (ver el `EventBus` del `mounted`). El número es `pendientes + anulaciones` —lo que de verdad
     * espera una decisión— y lo calcula él: aquí no se suma nada, ni se le resta uno al resolver.
     * Se vuelve a preguntar porque una resolución puede mover las dos cuentas a la vez —denegar
     * una pendiente con una anulación pedida encima— y descontar a mano acabaría mintiendo.
     *
     * #1119 · Y es el de **dos años**, el que corre y el siguiente, no el de la bandeja de un año:
     * pedido así, las vacaciones de enero solicitadas en octubre le llegaban al aprobador por correo
     * y no salían en este número. La suma también la hace el servidor, con la misma cuenta que pone
     * el número de cada año en el selector «Año» de la bandeja, para que los dos cuadren.
     *
     * Lo que **no** cubre es que otra persona pida vacaciones mientras este menú está abierto: eso
     * no pasa por esta sesión y haría falta un canal SSE. Hasta entonces, el número es el de la
     * última vez que este usuario tocó algo, y al entrar en Vacaciones ve la bandeja de verdad.
     *
     * Un fallo deja el badge a 0 y **no** se avisa: el menú tiene que abrirse igual, y que no
     * salga un número es mucho menos grave que un diálogo de error cada vez que se despliega el
     * panel. Quien aprueba lo ve igual al entrar en Vacaciones.
     *
     * Va por el carril (ver `created`): resolver una solicitud mientras la consulta anterior
     * sigue en vuelo deja dos respuestas en camino, y solo la última dice la verdad.
     *
     * Y **sin sesión no se pregunta**, aquí y no en cada llamante: este menú vive fuera de las
     * rutas —en la pantalla de login también está montado—, así que al arrancar puede pedir sin
     * token, y lo único que eso trae es un 401 (ver `haySesion`). La comprobación está en este
     * método porque es por donde pasan los tres caminos que piden el badge: el montaje, el aviso
     * de sesión lista y cada resolución.
     *
     * Lo que ya **no** depende de esto es que un 401 tardío eche a nadie: la petición puede salir
     * perfectamente autenticada con la cuenta A y contestar cuando ya está dentro B, y eso no lo
     * evita ninguna comprobación de este fichero. Lo cierra `cierreDeSesionPor401` en el manejador
     * de 401 de `DatabaseModel.sendRequest`, que es por donde pasa esta consulta y todas las demás
     * (revisión CODEX del PR #1735).
     */
    cargarBadgeVacaciones: function() {
      const self = this;
      if (!haySesion()) {
        self.olvidarBadgeVacaciones();
        return;
      }
      self.carrilBadge.lanzar(RhBandejaVacaciones.pendientesPorAnio(), {
        // #59 · Y de qué SESIÓN es la consulta. El carril solo sabía de orden: tras cambiar de
        // cuenta, la respuesta de la anterior seguía siendo «la última» y pintaba su número. La
        // clave se mira al llegar, así que esa respuesta se descarta.
        clave: identidadSesion(),
        deAhora: identidadSesion,
        // #472 · Y el número de la cuenta anterior no se queda mientras se pregunta por la nueva:
        // lo tira el carril al lanzar, en cuanto la sesión no es la del número que hay pintado.
        // `olvidarBadgeVacaciones` lo pone a 0 al cerrar sesión, pero la cuenta nueva puede llegar
        // sin pasar por ahí, y entonces enseñaba el contador de otra persona hasta que contestaba.
        vaciar: function() {
          self.badgeVacaciones = 0;
        },
        exito: function(res) {
          self.badgeVacaciones = (res && res.badge) || 0;
        },
        limpiar: function() {
          self.badgeVacaciones = 0;
        }
      });
    },
    /**
     * #59 · El contador al cerrar sesión: a cero y sin nada en vuelo.
     *
     * No se pregunta nada aquí —sin sesión no hay a quién— y hace falta `invalidar()` además de
     * poner el número a 0: una consulta de la cuenta que se va puede estar todavía en camino, y es
     * la que escribía su contador encima después del cambio.
     */
    olvidarBadgeVacaciones: function() {
      this.carrilBadge.invalidar();
      this.badgeVacaciones = 0;
    },
    normalize: function(str) {
      if (!str) return "";
      return ("" + str).toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
    },
    // Entradas del menu que NO son rutas de Framework7, sino apps servidas aparte (bajo el mismo
    // origen, como el CRM NEW en www/crm-new/, o una URL absoluta de fuera). Sin `external` el
    // router de F7 intentaria resolver "/crm-new/" contra routes.js, no encontraria ninguna ruta
    // y el clic no haria nada; con `external` el ancla se marca como externa, el router la ignora
    // y el navegador la abre (el handler global de app.vue la manda a una pestana nueva). Mismo
    // origen = el CRM lee la sesion de localStorage["session"] por su cuenta, sin handoff de
    // token (eso es solo el apano de desarrollo con Vite en :5173).
    //
    // Quien decide es el propio item del menu: `esExterno` lo trae digitaltpm-core 1.0.38 desde
    // el documento de menu de Mongo. Antes se deducia de la URL ("/crm-new/" o http(s)://), que
    // obligaba a tocar el front por cada app nueva que se sirviera aparte. Solo el booleano a
    // `true` abre fuera; `false`, ausente o cualquier otro valor es navegacion interna.
    abreComoExterno: function(item) {
      return !!item && item.esExterno === true;
    },
    getNombreUser: function() {
      const user = Utils.getUser();
      return user ? user.nombre : "";
    },
    getUsername: function() {
      const user = Utils.getUser();
      return user ? user.username : "";
    },
    getRolePriority: function() {
      const user = Utils.getUser();
      const roles = (user && user.roles) || [];
      const order = [
        { role: "ADMIN",          icon: "gear_alt_fill",         color: "red",     label: "Administrador" },
        { role: "DTYCAL",         icon: "checkmark_seal_fill",   color: "purple",  label: "DT y Calidad" },
        { role: "DIRECTOR",       icon: "star_fill",             color: "orange",  label: "Director" },
        { role: "INSPECTOR",      icon: "eye_fill",              color: "blue",    label: "Inspector" },
        { role: "PLANIFICADOR",   icon: "calendar",              color: "teal",    label: "Planificador" },
        { role: "TRAMITACION",    icon: "doc_text_fill",         color: "yellow",  label: "Tramitación" },
        { role: "FVYFP",          icon: "money_euro_circle_fill",color: "green",   label: "Facturación" },
        { role: "ADMINISTRACION", icon: "tray_full_fill",        color: "gray",    label: "Administración" },
        { role: "ADMINISTRATIVO", icon: "tray_full_fill",        color: "gray",    label: "Administrativo" },
        { role: "COMERCIAL",      icon: "briefcase_fill",        color: "deeporange", label: "Comercial" },
        { role: "CLIENTE",        icon: "person_2_fill",         color: "gray",    label: "Cliente" }
      ];
      for (var i = 0; i < order.length; i++) {
        if (roles.indexOf(order[i].role) > -1) return order[i];
      }
      return { role: null, icon: "person_crop_circle", color: "gray", label: "Usuario" };
    },
    getRoleIcon: function() {
      return this.getRolePriority().icon;
    },
    getRoleColor: function() {
      return this.getRolePriority().color;
    },
    getRoleLabel: function() {
      return this.getRolePriority().label;
    },
    closeSession: function() {
      var self = this;
      var app = self.$f7;
      app.dialog.confirm("¿Cerrar sesión?", function() {
        app.methods.removeSession();
        Flash.set("logged-out", true);
        app.views.main.router.navigate("/");
        app.panel.close("left");
      });
    }
  }
};
</script>